import { render, staticRenderFns } from "./ProducedProductForm.vue?vue&type=template&id=f643322e&scoped=true&"
import script from "./ProducedProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProducedProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProducedProductForm.vue?vue&type=style&index=0&id=f643322e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f643322e",
  null
  
)

export default component.exports